var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.label !== '')?_c('span',{staticClass:"label mr-1",class:_vm.labelClasses},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_vm._v(" "),_c('span',{class:_vm.valueClass},[_vm._t("default",[_vm._v(_vm._s(_vm.currencyValue))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }